export enum ErrorStrings {
  // Page Labels
  Error = 'VKDo',
  // Messages
  IncorrectUrl = 'rAoo',
}
